import Vue from 'vue';

const EventBus = new Vue();

EventBus.events = {
    'CHANGE_COLUMN_TYPE':'CHANGE_COLUMN_TYPE',


};

export default EventBus;
